<div class="ws-flex-container-vertical ws-flex-auto ws-stretch">
    <ag-grid-row-count [gridApi]="gridApi"
                       [gridOptions]="gridOptions"
                       [prefix]="null"
                       [suffix]="null"
                       class="ws-flex-auto"></ag-grid-row-count>
    <ws-ag-grid-angular [gridOptions]="gridOptions"
                        (gridReady)="onAgGridReady($event)">
    </ws-ag-grid-angular>
</div>
